import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 24px;
`;
export const Text = styled.div `
  margin-bottom: 20px;
`;
export const SecondaryText = styled.div `
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${Colors.GS600};
  margin-bottom: 12px;
`;
export const PerksContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
